/**
 * Espera de tela cheia, usada pelas rotas enquanto a sessão é restaurada, a
 * matrícula é trocada ou um chunk de tela ainda está baixando.
 *
 * Vive fora do App.tsx porque agora quem espera são os guards de rota, e não
 * mais um único ponto no topo da árvore.
 */

import React from 'react';

interface FullScreenLoaderProps {
  label: string;
  /**
   * Spinner maior, reservado à espera da sessão no boot — é o primeiro pixel
   * que o usuário vê, e era assim antes das rotas.
   */
  large?: boolean;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ label, large }) => (
  <div className="flex min-h-screen bg-[var(--color-background)] items-center justify-center">
    <div className="text-center">
      <i
        className={`fas fa-spinner fa-spin ${large ? 'text-5xl' : 'text-4xl'} text-[var(--color-accent)] mb-4`}
      ></i>
      <p className="text-[var(--color-muted)] font-medium">{label}</p>
    </div>
  </div>
);

export default FullScreenLoader;
